import { FR } from './france';

export const PM = FR;
